module.exports = __webpack_public_path__ + "2.png?3b6881e411ed22bc09c5409a16e6c7d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/2.png
// module id = 48
// module chunks = 0